import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import { Constants, State } from '../../app.constants';
import { ITitleState } from '../iTitleState';
import { LookupService } from '../../lookup.service';
export class StateSingleSelect extends State {
    isSelected: boolean;
}


@Component({
    selector: 'acl-state-single-select',
    template: `<div *ngIf="!fromDashboardsPage" class="mb-1 background-gray-lighter p-h">
                  <strong>State selection</strong>
              </div>

                <label *ngIf="!fromRestoreDataPage && !fromDashboardsPage" for="selState">State
                  <select id="selState" name="selState"
                      class="form-control" (change)="onChange($event.target.value)">
                      <option value=""></option>
                          <option *ngFor="let option of allStates" [value]="option.abbr">{{option.abbr}}</option>
                  </select>
                  </label>

                  <label *ngIf="fromRestoreDataPage" for="selState">State
                  <select id="selState" name="selState"
                      class="form-control" (change)="onChange($event.target.value)">
                      <option value=""></option>
                          <option *ngFor="let state of states" [value]="state">{{state}}</option>
                  </select>
                  </label>

                  <label *ngIf="fromDashboardsPage && !fromTitleVI" for="selState" style="width: 50%">State
                  <select id="selState" name="selState"
                      class="form-control" (change)="onChange($event.target.value)">
                      <option value=""></option>
                          <option *ngFor="let option of allStates" [value]="option.abbr">{{option.abbr}}</option>
                  </select>
                  </label>

                  <label *ngIf="fromDashboardsPage && fromTitleVI" for="selGrantee">Grantee
                  <select id="selGrantee" name="selState"
                      class="form-control" (change)="onChange($event.target.value)" aria-label="Grantee Selection" >
                      <option value=""></option>
                          <option *ngFor="let option of allStates" [value]="option.region">{{option.abbr}}</option>
                  </select>
                  </label>
              `,
    styles: [
        'label { display: inline-block; padding: 0 1em; }',
        'label > select { display: block; }'
    ]
})
export class StateSingleSelectComponent implements OnInit, OnChanges {

    @Input() states: Array<ITitleState>;
    @Input() fromRestoreDataPage: boolean = false;
    @Input() fromDashboardsPage: boolean = false;
    @Input() isAclUser: boolean = false;
    @Input() fromTitleVI: boolean = false;
    @Output() selectedStates: EventEmitter<ITitleState[]> = new EventEmitter<ITitleState[]>();
    @Output() disabledSingleStateFlag: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() selectedSingleState:EventEmitter<any> = new EventEmitter();

    allStates: State[] = Constants.T7STATES.sort((left, right) => left.abbr < right.abbr ? -1 : 1);
    constructor(public _lookupService: LookupService) { }

    ngOnInit() {
        if (this.fromDashboardsPage && !this.fromTitleVI) {
            if (this.isAclUser) {
            this.allStates.push(new State('National Data', ''))
            } else {
                this.allStates = [];
                this.allStates.push(new State(localStorage.getItem('org'),''))
                this.allStates.push(new State('National Data', ''))
            }
        } else if (this.fromDashboardsPage && this.fromTitleVI) {
            this.allStates = [];
            this._lookupService.getGranteeDisplayItems([]).subscribe(data => {
                  if (data && data.length > 0) {
                    if (this.isAclUser) {
                    data.forEach(grantee => this.allStates.push(new State(grantee.displayName, grantee.granteeId)))
                      this.allStates.push(new State('National Data', 'national'))
                    } else {
                        data.forEach(grantee => {
                            if (grantee.org == localStorage.getItem('org')) {
                                this.allStates.push(new State(grantee.displayName,grantee.granteeId))
                                this.allStates.push(new State('National Data', 'national'))
                            }
                        })
                    }
                  }
                })
        }
    }

    ngOnChanges(changes: SimpleChanges) {

    }

    onChange(state: string) {
        const selected = [];
        // this.lookupService.getTitleStates(this.claimService.currentTitle)
        //     .subscribe(data => {
        if (this.fromRestoreDataPage || this.fromDashboardsPage) {
            this.selectedSingleState.emit(state);
        }
        if (state) {
            selected.push(this.states?.find(x => x.state === state));
            this.selectedStates.emit(selected);
        }
        // });
        if (selected.length > 0) {
            this.disabledSingleStateFlag.emit(false);
        } else {
            this.disabledSingleStateFlag.emit(true);
        }
    }

}
